export class UserDataModel {
  constructor(
    public email = '',
    public description = '',
    public amount = '',
    public fullName = '',
  ) {
  }
}

export interface RequestUniqueLink {
  email: string;
  description: string;
  merchantId: number;
  token: string;
  amount: string;
  name: string;
}

export interface ResponseUniqueLink{
  CODE: string;
  DESC: string;
  DATA: UniqueLinkResponse;
}

export interface UniqueLinkResponse {
  url: string;
  operacion: string;
}
